var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tweetUser
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h2", [_vm._v("User profile")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("img", {
                    staticClass: "m-3",
                    staticStyle: { "border-radius": "50%" },
                    attrs: { src: _vm.tweetUser.image_src }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.tweetUser.profile_items, function(
                itemValue,
                itemName
              ) {
                return _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-5 t" }, [
                    _c("strong", [_vm._v(_vm._s(itemName))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-7" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(itemValue) +
                        "\n            "
                    )
                  ])
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("tweet-user-additional-data")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }